import { Typography } from 'antd';
import styled from 'styled-components';
import { sharedTypographyStyles } from '../../styled';

export const StyledText = styled(Typography.Text)`
    ${sharedTypographyStyles};
    font: ${({ $type = 'body2', $theme }) => $theme.fonts[$type]};
`;
